import BaseListPresenter from "../../../base/BaseListPresenter";
import { dialog, Button } from "nq-component";
import InputFactory from "../../../components/InputFactory";
import { aggregateUseCase } from "../../../usecases/object";
import { type } from "@testing-library/user-event/dist/type";

class GeneratePayrollPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
    this.payrollTypeLabel = [
      {
        label: "Basic Pay",
        value: "Basic Pay",
      },
      {
        label: "Augmentation Pay",
        value: "Augmentation Pay",
      },
      {
        label: "J.O Salary",
        value: "J.O Salary",
      },
      {
        label: "Individual Payroll",
        value: "Individual Payroll",
      },
      {
        label: "Special Payroll",
        value: "Special Payroll",
      },
    ];
  }

  init() {
    this.limit = 50;
    // this.limit = 10;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.filterEarnings = {};
    this.filterEmployment = {};
    this.filterAdditional = {};
    this.filterJobOrder = {};
    this.include = [
      "payrollRelation.classification",
      "employmentType",
      "position",
      "selectedSchedule",
    ];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { Firstname: 1, Middlename: 1, Surname: 1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterEarnings,
        ...this.filterEmployment,
        ...this.filterAdditional,
        ...this.filterJobOrder,
      },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    const pipeline = [
      {
        $project: {
          payrollRelation: 1,
        },
      },

      // {
      //   $match: {
      //     payrollRelation: {
      //       $elemMatch: {
      //         id: "GVp4O5GflyAWNc0TwkKB2RrRDNa0Zo",
      //         "classification.id": "9787597c-6da2-4cb2-bae0-de7641116f77",
      //       },
      //     },
      //   },
      // },
    ];
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      const sample = await aggregateUseCase().execute(collection, []);

      console.log("SAMPLE", sample);
      const test = await aggregateUseCase().execute(collection, pipeline);
      console.log("testss", test);
      this.objects = objects;
      // this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  onSelect(index) {
    const selectedObjects = this.view.state.selected;
    const selected = this.objects[index];

    const i = selectedObjects.findIndex((item) => item.id === selected.id);

    if (i > -1) {
      selectedObjects.splice(i, 1);
    } else {
      selectedObjects.push(selected);
    }

    this.view.setState({ selected: selectedObjects });
  }

  getPayrollLabel() {
    return this.payrollTypeLabel;
  }

  setEmploymentOptions() {
    const { employment } = this.view.state;

    const filtered = employment.filter((employmentType) => {
      return employmentType.name !== "Job Order";
    });

    const type = filtered.map((employmentType) => ({
      label: employmentType.name,
      value: employmentType,
    }));

    return type;
  }

  setAdditionalOptions() {
    const { payrollType, employmentType, allowance, employment } =
      this.view.state;

    const formattedAllowance = allowance.map((item) => ({
      label: item,
      value: item,
    }));

    const baseOptions = [
      { label: "General Payroll", value: "General Payroll" },
      { label: "Addendum Payroll", value: "Addendum Payroll" },
      { label: "Addendum Back-Pay", value: "Addendum Back-Pay" },
      { label: "Newly-hired", value: "Newly-hired" },
      { label: "Salary", value: "Salary" },
    ];

    const individualOptions = [
      { label: "Initial Salary (Basic)", value: "Initial Salary (Basic)" },
      { label: "Last Salary (Basic)", value: "Last Salary (Basic)" },
      ...(employmentType !== "Job Order"
        ? [
            { label: "Initial Salary (AP)", value: "Initial Salary (AP)" },
            { label: "Last Salary (AP)", value: "Last Salary (AP)" },
            {
              label: "Salary Differential (Basic)",
              value: "Salary Differential (Basic)",
            },
            { label: "Backwage (BASIC)", value: "Backwage (BASIC)" },
            ...(employmentType === "Co-term" || employmentType === "Contractual"
              ? []
              : [{ label: "Initial RATA", value: "Initial RATA" }]),
          ]
        : []),
    ];

    if (
      payrollType === "Augmentation Pay" &&
      (employmentType === "Organic" ||
        employmentType === "Co-term" ||
        employmentType === "Coterminos" ||
        employmentType === "Coterminous")
    ) {
      return baseOptions.filter(
        (option) =>
          option.label !== "Salary" && option.label !== "Addendum Back-Pay"
      );
    } else if (payrollType === "J.O Salary") {
      return baseOptions.filter(
        (option) =>
          option.label !== "Newly-hired" &&
          option.label !== "General Payroll" &&
          option.label !== "Addendum Back-Pay"
      );
    } else if (payrollType === "Special Payroll") {
      return [...formattedAllowance];
    } else if (payrollType === "Individual Payroll") {
      return [...individualOptions];
    } else {
      return baseOptions.filter(
        (option) => option.label !== "Newly-hired" && option.label !== "Salary"
      );
    }
  }

  handleAddendumCategory(field, value) {
    this.view.setState({ [field]: value, addendumType: "" });
  }

  getAddendumLabel() {
    const { additionalSelectValue } = this.view.state;

    const baseOptions = [
      { label: "Basic Addendum", value: "Basic Addendum" },
      { label: "Addendum Back-Pay", value: "Addendum Back-Pay" },
    ];

    if (additionalSelectValue === "Addendum Payroll") {
      return [...baseOptions];
    }
    return [];
  }

  setSelectedEmployee() {
    const { objects } = this.view.state;

    const employees = objects.map((item) => {
      const surname = item.surname ?? "";
      const Firstname = item.Firstname ?? "";
      const Middlename = item.Middlename ?? "";
      const fullName = `${surname} ${Firstname} ${Middlename}`.trim();
      return { label: fullName, value: fullName, id: item.id };
    });

    return employees;
  }

  getFileUpload = (event) => {
    const file = event.target.files[0];

    if (file && file.type === "text/csv") {
      const reader = new FileReader();

      reader.onload = (e) => {
        const text = e.target.result;
        const parsedData = this.getParseCSV(text);

        this.view.setState({ csvData: parsedData, filename: file.name });
      };

      reader.readAsText(file);
    } else {
      alert("Please upload a valid CSV file.");
      this.view.setState({ fileName: "" });
    }
  };

  getParseCSV = (text) => {
    const rows = text.split("\n");
    const headers = rows[0].split(",").map((header) => header.trim());
    const csvRegex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;

    const data = rows.slice(1).map((row) => {
      const values = row.split(csvRegex);
      const entry = {};
      headers.forEach((header, index) => {
        const value = values[index]
          ? values[index].replace(/^"|"$/g, "").trim()
          : "";
        entry[header] = value;
      });

      return entry;
    });

    return data.filter((entry) => Object.keys(entry).length > 0);
  };

  getHandleGenerate = () => {
    dialog.fire({
      html: (
        <div className="">
          <div className="row p-2">
            <h5 className="text-left">Please input necessary details!</h5>

            <div
              className="col-md-12"
              style={{ width: "100%", margin: "0 auto" }}
            >
              <label className="ms-2 mt-2">Payroll Code</label>
              <div className="ms-2 me-2">
                <InputFactory
                  type="String"
                  onChange={(value) => this.handlePayrollCode(value)}
                />
              </div>
            </div>
          </div>
          <hr></hr>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => this.handleContinue()}
            >
              Continue
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  };

  handleContinue() {
    dialog.close();
    this.view.setState({ payrollListing: true });
  }

  handlePayrollCode(value) {
    this.view.setState({ payrollCode: value });
  }

  filterSubmit(where) {
    console.log("WHERE", where);
    this.reset();
    this.filterEarnings = where;
    this.getObjects();
  }

  filterSubmit2(where) {
    console.log("WHERE", where);
    this.reset();
    this.filterEmployment = where;
    this.getObjects();
  }
  filterSubmit3(where) {
    console.log("WHEREsssssss", where);
    this.reset();
    this.filterAdditional = where;
    this.getObjects();
  }
  filterSubmit4(where) {
    this.reset();
    this.filterJobOrder = where;
    this.getObjects();
  }

  filterOrigin() {
    this.reset();
    const where = {};
    this.filterPayroll = where;
    this.getObjects();
  }

  async getPayrollTypeChange(field, value, ids) {
    const relation = await this.findObjectUseCase.execute("payroll_relation", {
      keys: ["classification"],
      include: ["classification"],
      where: {
        "classification.id": { $in: ids },
      },
    });

    console.log("sample", relation);

    // const classification = await this.findObjectUseCase().execute(
    //   "payroll_relation"
    // );
    // const isSpecialOrIndividual =
    //   value === "Special Payroll" || value === "Individual Payroll";

    // if (isSpecialOrIndividual) {
    //   this.reset();
    //   this.filterPayroll = {};
    //   this.filterEmployment = {};
    //   this.getEmploymentTypeChange("employmentType", "");
    //   this.getSelectedEmployees("");
    // } else if (value === "General Payroll" || value === "Addendum Payroll") {
    //   if (field === "payrollType") {
    //     this.getChangeFilterType("String", value, "payrollType");
    //   }
    // }
    // else
    // {
    //   if (field === "payrollType") {
    //     this.view.setState({ [field]: value });
    //   }
    // }
    this.getChangeFilterType(
      "Relation",
      relation, // This is a string, not an object
      "classification"
    );
    this.getEmploymentTypeChange("employmentType", "");

    this.view.setState({ [field]: value });
  }

  getChangeFilterType(type, value, field) {
    const where = {};
    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id };
        }
        break;
      case "Relation":
        // Special case: array of classification objects
        if (
          Array.isArray(value) &&
          value.length > 0 &&
          typeof value[0] === "object" &&
          value[0].id
        ) {
          const ids = value.map((v) => v.id);

          console.log("ids", ids);

          // console.log("ids", ids);
          where["payrollRelation"] = {
            $elemMatch: {
              id: { $in: ids },
            },
            $ne: [],
            // "classification.id": { $in: ids },
            // classification: { id: { $in: ids } },
          };
        } else if (value?.id) {
          // Default relation filter
          where[field] = { id: value.id };
        }
        break;
      case "Boolean":
        where[field] = value;
        break;
      default:
        where[field] = { $regex: value, $options: "i" };
    }
    if (field === "classification") {
      this.getfilterSubmit(where, "payrollRelation");
    } else if (field === "employmentType") {
      this.getfilterSubmit(where, field);
    } else if (field === "classificationSecond") {
      this.getfilterSubmit(where, "payrollRelation");
    } else if (field === "payrollType") {
      this.getfilterSubmit(where, field);
    }
  }

  getfilterSubmit(where, field) {
    switch (field) {
      case "payrollRelation":
        this.filterSubmit(where);
        break;
      case "employmentType":
        this.filterSubmit2(where);
        break;
      case "classificationSecond":
        this.filterSubmit3(where);
      case "payrollType":
        this.filterSubmit4(where);
        break;
      default:
    }
  }

  getEmploymentTypeChange(field, value) {
    this.getChangeFilterType("Pointer", value, "employmentType");
    this.view.setState({
      [field]: value.name,
      additionalSelectValue: "",
      selectedEmployees: "",
    });

    // this.view.setState({
    //   [field]: value,
    //   additionalSelectValue: "",
    //   selectedEmployees: "",
    // });
  }

  async getAdditionalSelectChange(value) {
    const combinations = await this.findObjectUseCase.execute(
      "payroll_combination",
      {
        keys: ["payrollType"],
        where: {
          payrollType: value,
        },
      }
    );

    let ids = [];

    for (const item of combinations) {
      ids.push(item.id);
    }

    const relation = await this.findObjectUseCase.execute("payroll_relation", {
      keys: ["classification"],
      include: ["classification"],
      where: {
        "classification.id": { $in: ids },
      },
    });
    this.view.setState({ additionalSelectValue: value });
    if (this.view.state.payrollType !== "J.O Salary") {
      this.getChangeFilterType(
        "Relation",
        relation, // This is a string, not an object
        "classificationSecond"
      );
    }
    // this.filterOrigin({});
  }
  getSelectedEmployees(selectedOption) {
    this.view.setState({
      selectedEmployees: selectedOption.value,
      selectedEmployeeID: selectedOption.id,
    });
    // this.filterOrigin({});
  }

  getOnChange(dateString) {
    const [startDate, endDate] = Array.isArray(dateString)
      ? dateString
      : [null, null];
    this.view.setState({
      startDate: startDate ? startDate.toDate() : "",
      endDate: endDate ? endDate.toDate() : "",
    });
  }
}

export default GeneratePayrollPresenter;
